<template>
  <div>
    <el-tabs type="border-card" class="fullHeight" @tab-click="clickTab">
      <el-tab-pane :label="$t('Tareas')" class="paddingBody content">
        <center v-if="hidden === false">
          <el-alert type="info">
            <el-progress :status="step_percentage === 100 ? 'success' : null" :percentage="step_percentage"
              style="margin-bottom: 5px;"></el-progress>
            <small style="font-size: 15px;">{{ step_loading_txt }}</small>
          </el-alert>
          <br><br>
        </center>
        <center v-if="loadingAllDataRequired">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <div v-if="!loadingAllDataRequired">
          <span style="display: inline">Mostrar riesgos pendientes:</span>
          <el-checkbox style="margin-left: 10px; margin-bottom: 20px; display: inline" border v-model="pendiente">{{
            $t("Mostrar riesgos pendientes")
          }}</el-checkbox>
          <i style="color: #f44c00; font-weight: bold; display: inline; margin-left: 10px; margin-right: 10px;"
            class="el-icon-d-arrow-left"></i>
          <el-alert style="display: inline" :closable="false" type="info">
            Haga click en el botón de la izquierda para ver todas sus tareas
            pendientes
          </el-alert>
          <br /><br>
        </div>

        <CompShowPage v-if="contract != null && inventory != null && !loadingAllDataRequired
          " :inventory="inventory" :workflows="workflows" :contractPeople="contractPeople" :contract="contract"
          :filtro_usuario_riesgo="pendiente" />
        <br />
      </el-tab-pane>
      <el-tab-pane :label="$t('Contrato')" class="paddingBody">
        <center v-if="!contract">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <MostrarContrato v-else :key="forceRender" ref="viewContract" v-if="contract" :contract="contract"
          :fatherArea="fatherArea" :area="area" :workflows="workflows" :peopleContract="usersFaena" />
      </el-tab-pane>
      <el-tab-pane label="Seguimiento" class="paddingBody">
        <center v-if="loading_seguimiento">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <el-table v-else :data="seguimiento" style="width: 100%" height="600"
          header-cell-class-name="header-cell-class-table-gray" empty-text="No se han encontrado datos de seguimiento">
          <el-table-column width="110">
            <template slot-scope="scope">
              <img v-if="scope.row.type === 'add'" src="../../assets/icons/add.png" width="50" />
              <img v-if="scope.row.type === 'delete'" src="../../assets/icons/delete.png" width="50" />
              <img v-if="scope.row.type === 'update'" src="../../assets/icons/update.png" width="50" />
            </template>
          </el-table-column>
          <el-table-column width="260" prop="user" label="Nombre"></el-table-column>
          <el-table-column width="260" label="Fecha">
            <template slot-scope="scope">{{
              scope.row.date | moment("DD/MM/YYYY hh:mm:ss")
            }}</template>
          </el-table-column>
          <el-table-column prop="action" label="Acción"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane v-if="inventory && inventory._id" class="paddingBody content" :label="$t('Resumen de las revisiones')">
        <center v-if="loading_summary">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <div v-else>
          <small>Búsqueda avanzada (Nombre de tarea, nombre del riesgo, nombre revisor pendiente)</small>
          <el-input style="margin-bottom: 20px; margin-top: 7px;" v-model="search" size="medium"
            placeholder="Ingrese su texto aquí" />
          <el-table
            :data="summary.data.filter(data => !search || (data.tarea.toLowerCase().includes(search.toLowerCase()) || data.riesgo.toLowerCase().includes(search.toLowerCase()) || data.actual_revisor.map(v => v.toLowerCase()).includes(search.toLowerCase())))"
            style="width: 100%;" header-cell-class-name="header-cell-class-table-gray">
            <el-table-column fixed prop="tarea" label="Tarea">
            </el-table-column>
            <el-table-column prop="riesgo" label="Riesgo">
            </el-table-column>
            <el-table-column align="center" label="Última Revisión">
              <el-table-column prop="ultimo_rol" label="Rol" width="250">
              </el-table-column>
              <el-table-column prop="ultimo_revisor" label="Usuario" width="220">
              </el-table-column>
              <el-table-column prop="ultima_fecha" label="Fecha" width="170">
                <template slot-scope="scope">
                  {{ scope.row.ultima_fecha | moment("DD MMM YYYY HH:mm") }}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="Revisión Pendiente">
              <el-table-column prop="perfiles_actuales" label="Roles Pendientes" width="250">
                <template slot-scope="scope">
                  <ul style="padding-inline-start: 20px;">
                    <li style="color: red;" v-for="(item, index) in scope.row.perfiles_actuales" :key="`A${index}`">{{
                      item
                    }}</li>
                  </ul>
                </template>
              </el-table-column>
              <el-table-column prop="actual_revisor" label="Revisores Pendientes" width="220">
                <template slot-scope="scope">
                  <ul style="padding-inline-start: 20px;">
                    <li style="color: red;" v-for="(item, index) in scope.row.actual_revisor" :key="`B${index}`">{{ item
                    }}</li>
                  </ul>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="inventory && inventory.motivos" class="paddingBody content"
        :label="$t('Motivos cambios a borrador')">
        <el-table :data="inventory.motivos" style="width: 100%;" header-cell-class-name="header-cell-class-table-gray">
          <el-table-column width="400" prop="fecha" label="Fecha">
            <template slot-scope="scope">
              {{ scope.row.fecha | moment("LLLL") }}
            </template>
          </el-table-column>
          <el-table-column prop="motivo" label="Motivo">
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane v-if="inventory" @tab-click="clickTab" class="paddingBody content" :label="$t('Comentarios')">
        <el-button
          v-if="!loadingComentarios && !['coordinator', 'contractor_coordinator'].includes($store.getters.role.role) && !$store.getters.user.readonly"
          @click="addComentario = true;" type="primary" size="small">Agregar
          Comentario</el-button>
        <center v-if="loadingComentarios">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <el-table v-else :data="comentarios" style="width: 100%; margin-top: 20px;"
          header-cell-class-name="header-cell-class-table-gray">
          <el-table-column prop="nombre" label="Usuario">
          </el-table-column>
          <el-table-column prop="rol" label="Rol">
            <template slot-scope="scope">
              {{ reviewerRoles[scope.row.rol] }}
            </template>
          </el-table-column>
          <el-table-column prop="fecha" label="Fecha">
            <template slot-scope="scope">
              {{ getHumanDate(scope.row.fecha) }}
            </template>
          </el-table-column>
          <el-table-column prop="comentario" label="Comentario">
          </el-table-column>
          <el-table-column label="Opciones"
            v-if="!['coordinator', 'contractor_coordinator'].includes($store.getters.role.role) && !$store.getters.user.readonly">
            <template slot-scope="scope">
              <el-button v-if="scope.row.id_usuario === $store.getters.user._id || this.role.admin === true"
                @click="deleteComentario(scope.row._id)" type="danger" size="small">Eliminar</el-button>
              <el-button v-if="scope.row.id_usuario === $store.getters.user._id || this.role.admin === true"
                @click="openEditComentario(scope.row)" type="info" size="small">Editar</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane class="paddingBody content" :label="$t('Correos de revisores BHP')">
        <el-row>
          <el-col :sm="8"
            v-if="showItem() === true && contract && contract.revisores && getUser(contract.revisores.coordinator).length > 0">
            <b style="color: orangered">COORDINADOR</b><br>
            <ul style="list-style-position: inside; padding-left: 0; margin-bottom: 50px;">
              <li v-for="(item, index) in getUser(contract.revisores.coordinator)" :key="`user-1-${index}`"
                style="margin-bottom: 10px;">{{
                  `${item.nombre} ${item.apellido} - ${item.email}` }}</li>
            </ul>
          </el-col>
          <el-col :sm="8" v-if="contract && contract.revisores && getUser(contract.revisores.owner).length > 0">
            <b style="color: orangered">DUEÑO DE CONTRATO</b><br>
            <ul style="list-style-position: inside; padding-left: 0; margin-bottom: 50px;">
              <li v-for="(item, index) in getUser(contract.revisores.owner)" :key="`user-2-${index}`"
                style="margin-bottom: 10px;">{{ `${item.nombre}
                                ${item.apellido} - ${item.email}` }}</li>
            </ul>
          </el-col>
          <el-col :sm="8"
            v-if="showItem() === true && contract && contract.revisores && getUser(contract.revisores.risk).length > 0">
            <b style="color: orangered">ESPECIALISTA DE RIESGO</b><br>
            <ul style="list-style-position: inside; padding-left: 0; margin-bottom: 50px;">
              <li v-for="(item, index) in getUser(contract.revisores.risk)" :key="`user-3-${index}`"
                style="margin-bottom: 10px;">{{ `${item.nombre}
                                ${item.apellido} - ${item.email}` }}</li>
            </ul>
          </el-col>
          <el-col :sm="8"
            v-if="showItem() === true && contract && contract.revisores && getUser(contract.revisores.hse).length > 0">
            <b style="color: orangered">HSE</b><br>
            <ul style="list-style-position: inside; padding-left: 0; margin-bottom: 50px;">
              <li v-for="(item, index) in getUser(contract.revisores.hse)" :key="`user-4-${index}`"
                style="margin-bottom: 10px;">{{ `${item.nombre}
                                ${item.apellido} - ${item.email}` }}</li>
            </ul>
          </el-col>
          <el-col :sm="8"
            v-if="showItem() === true && contract && contract.revisores && getUser(contract.revisores.health).length > 0">
            <b style="color: orangered">ESPECIALISTA DE SALUD</b><br>
            <ul style="list-style-position: inside; padding-left: 0; margin-bottom: 50px;">
              <li v-for="(item, index) in getUser(contract.revisores.health)" :key="`user-5-${index}`"
                style="margin-bottom: 10px;">{{ `${item.nombre}
                                ${item.apellido} - ${item.email}` }}</li>
            </ul>
          </el-col>
          <el-col :sm="8"
            v-if="showItem() === true && contract && contract.revisores && getUser(contract.revisores.safety).length > 0">
            <b style="color: orangered">ESPECIALISTA DE SEGURIDAD</b><br>
            <ul style="list-style-position: inside; padding-left: 0; margin-bottom: 50px;">
              <li v-for="(item, index) in getUser(contract.revisores.safety)" :key="`user-6-${index}`"
                style="margin-bottom: 10px;">{{ `${item.nombre}
                                ${item.apellido} - ${item.email}` }}</li>
            </ul>
          </el-col>
          <el-col :sm="8"
            v-if="showItem() === true && contract && contract.revisores && getUser(contract.revisores.environment).length > 0">
            <b style="color: orangered">ESPECIALISTA DE MEDIOAMBIENTE</b><br>
            <ul style="list-style-position: inside; padding-left: 0; margin-bottom: 50px;">
              <li v-for="(item, index) in getUser(contract.revisores.environment)" :key="`user-7-${index}`"
                style="margin-bottom: 10px;">{{
                  `${item.nombre} ${item.apellido} - ${item.email}` }}</li>
            </ul>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="Agregar Comentario" :visible.sync="addComentario" width="30%" :before-close="handleClose">
      <el-form>
        <el-form-item label="Ingrese su comentario">
          <el-input type="textarea" :rows="3" :placeholder="$t('Ingrese sus comentarios')" v-model="comentario.comentario"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
        <el-button type="primary" @click="addComentarioBD">Confirmar</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Editar Comentario" :visible.sync="editComentario" width="30%" :before-close="handleClose">
      <el-form>
        <el-form-item label="Ingrese su comentario">
          <el-input type="textarea" :rows="3" :placeholder="$t('Ingrese sus comentarios')" v-model="comentario.comentario"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
        <el-button type="primary" @click="actualizarComentario">Confirmar</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="false">
      <template slot="title">
        <center>
          <span style="font-size: 14px">PARA CONTINUAR DEBES INICIAR SESIÓN</span>
          <p style="font-size: 12px; color: #dd6f2a">
            Ingresa con tus credenciales para realizar la evaluación de riesgos
          </p>
        </center>
      </template>
      <center v-if="loadingLogin">
        <br />
        <br />
        <Circle9 style="margin-bottom: 8px"></Circle9>
        <small>{{ loading_desc }}</small>
        <br />
        <br />
      </center>
      <div v-else>
        <el-form :model="credentials" status-icon ref="formLogin">
          <el-form-item prop="rut" label="Nombre de usuario / RUT">
            <el-input :placeholder="$t('Ingrese nombre de usuario')" v-model="credentials.rut"></el-input>
          </el-form-item>
          <el-form-item prop="password" label="Contraseña" style="margin-bottom: 0px">
            <el-input type="password" :placeholder="$t('Ingrese contraseña')" @keyup.native.enter="submit"
              v-model="credentials.password"></el-input>
          </el-form-item>
        </el-form>
        <div v-if="errors.length > 0">
          <br />
          <br />
          <center>
            <li style="color: red; list-style: none" v-for="error in errors" :key="error">
              <b>{{ error }}</b>
            </li>
          </center>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!loadingLogin">
        <el-button type="primary" @click="submit">Aceptar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Circle9 } from "vue-loading-spinner";
import { mapActions } from "vuex";
import moment from "moment";
import inventoryRequirements from "@/mixins/inventoryRequirements";
import CompShowPage from "@/components/C_ShowPage.vue";
import MostrarContrato from "@/components/MostrarContrato.vue";
import axios from "axios";

export default {
  mixins: [inventoryRequirements],
  components: {
    CompShowPage,
    MostrarContrato,
    Circle9,
  },
  data() {
    return {
      loadingComentarios: false,
      reviewerRoles: {
        admin: "Administrador de Plataforma",
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente",
        contractor_hse: "HSE Contratista",
        contract_owner: "Dueño de Contrato",
        administrator: "Administrador de Contrato",
        hse: "HSE",
        owner: "Dueño de Contrato",
        risk: "Especialista de Riesgo",
        manager: "Gerente",
        super: "Superintendente",
        general_manager: "Gerente General",
      },
      roles_contratistas: [
        "contractor_hse",
        "contract_owner",
        "administrator",
      ],
      id_comentario: null,
      comentario: {
        comentario: "",
      },
      addComentario: false,
      editComentario: false,
      comentarios: [],
      search: "",
      loading_summary: false,
      summary: {
        data: [],
        status: false
      },
      pendiente: false,
      loading_seguimiento: false,
      errors: [],
      loadingLogin: false,
      loading_desc: "",
      dialogVisible: false,
      credentials: {
        rut: "",
        password: "",
      },
      forceRender: 0,
      ready: false,
      auxStatus: {
        0: { text: "Borrador", colorClass: "gray" },
        1: { text: "Revisión", colorClass: "yellow" },
        2: { text: "Aprobado", colorClass: "green" },
        3: { text: "Importado Borrador", colorClass: "gray" },
      },
      seguimiento: [],
    };
  },
  async created() {
    const params = this.getUrlVars();
    const my_role = params.rol;
    if (this.$store.getters.isLoggedIn === false) {
      if (!my_role) {
        this.$router.push({ name: "homePage" });
      }
    }
    if (this.$store.getters.isLoggedIn === false) {
      this.dialogVisible = true;
    }
    this.ready = true;
    if (this.$store.getters.areas.length === 0) {
      this.getAreasFaena();
    }
    if (this.$store.getters.empresas.length === 0) {
      this.getEmpresasFaena();
    }
  },
  watch: {
    step_percentage(newVal, oldVal) {
      if (newVal === 100) {
        setTimeout(() => this.hidden = true, 1500);
      }
    },
    inventory(newVal, oldVal) {
      this.getSeguimiento(newVal._id);
    },
    "$store.getters.inventario": {
      handler(after, before) {
        this.inventory = this.$store.getters.inventario;
      },
      deep: true,
    },
    "$store.getters.actualContract": {
      handler(after, before) {
        this.contract = after;
      },
      deep: true,
    },
    contract: {
      handler() {
        if (this.contract && this.contract.nombre) {
          this.setSubTitle(`${this.contract.nombre}`);
        }
        this.forceRender = this.forceRender + 1;
      },
    },
  },
  methods: {
    ...mapActions([
      "setSubTitle",
      "getUsersFaena",
      "getAreasFaena",
      "getEmpresasFaena",
    ]),
    showItem() {
      if (['5a6f78417b772dcfe68241e5', '5a6f784e7b772dcfe68241f4'].includes(this.$store.getters.role.faena_id) && this.roles_contratistas.includes(this.$store.getters.role.role)) {
        return false;
      } else {
        return true;
      }
    },
    getUser(data) {
      var newArray = this.$store.getters.usersFaena.filter(function (el) {
        return data.includes(el._id)
      });
      return newArray;
    },
    handleClose() {
      this.comentario = {
        comentario: "",
      }
      this.id_comentario = null;
      this.editComentario = false;
      this.addComentario = false;
    },
    openEditComentario(comentario) {
      this.id_comentario = comentario._id;
      this.comentario.comentario = comentario.comentario;
      this.editComentario = true;
    },
    deleteComentario(_id) {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      this.$confirm(
        'Estás a punto de eliminar un comentario. ¿Deseas Continuar?',
        'Advertencia',
        {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning',
        },
      )
        .then(async () => {
          await axios.post(`/inventarios/deleteComentarios`, {
            _id: _id
          }, config);
          this.getComentarios();
        })
        .catch(() => {
        });
    },
    getHumanDate(date) {
      return moment(date).format("DD MMMM YYYY HH:mm");
    },
    async actualizarComentario() {
      this.$confirm(
        'Estás a punto de actualizar un comentario. ¿Deseas Continuar?',
        'Advertencia',
        {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning',
        },
      )
        .then(async () => {
          const config = {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          };
          if (this.comentario.comentario === "") {
            this.$notify({
              duration: 3000,
              title: "Atención",
              message: "Para continuar debes completar todos los campos",
              type: "Warning",
            });
          } else {
            await axios.post(`/inventarios/updateComentario`, {
              _id: this.id_comentario,
              comentario: this.comentario.comentario
            }, config);
            this.getComentarios();
            this.handleClose();
          }
        })
        .catch(() => {
        });
    },
    async addComentarioBD() {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      if (this.comentario.comentario === "") {
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: "Para continuar debes completar todos los campos",
          type: "Warning",
        });
      } else {
        await axios.post(`/inventarios/addComentario`, {
          id_usuario: this.$store.getters.user._id,
          rol: this.$store.getters.role.role,
          id_inventario: this.inventory._id,
          nombre: `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`,
          comentario: this.comentario.comentario,
          fecha: new Date(),
          leido: false
        }, config);
        this.getComentarios();
        this.handleClose();
      }
    },
    async getComentarios() {
      this.loadingComentarios = true;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      let response = await axios.post(`/inventarios/getAllComentarios`, {
        id_inventario: this.inventory._id
      }, config);
      this.comentarios = response.data;
      this.loadingComentarios = false;
    },
    clickTab(tab) {
      if (tab.label === "Seguimiento") {
        this.getSeguimiento(this.inventory._id);
      }
      if (tab.label === "Resumen de las revisiones") {
        this.getSummary(this.inventory._id);
      }
      if (tab.label === "Comentarios") {
        this.getComentarios();
      }
    },
    getUrlVars() {
      const vars = [];
      let hash;
      const hashes = window.location.href
        .slice(window.location.href.indexOf("?") + 1)
        .split("&");
      for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split("=");
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    },
    async submit() {
      this.errors = [];
      this.loadingLogin = true;
      this.loading_desc = "";
      const self = this;
      this.$refs.formLogin.validate(async (valid) => {
        if (valid) {
          const response = await this.$store.dispatch(
            "login",
            this.credentials
          );
          if (!response.success) {
            this.errors.push(response.error);
            this.loadingLogin = false;
            return;
          }

          const params = this.getUrlVars();
          const my_role = params.rol;
          const id_contrato = window.location.pathname.substring(15, 39);

          this.resetInventory();
          // Obtener Contrato
          this.loading_desc = "OBTENIENDO CONTRATO ...";
          await this.getContract(id_contrato);

          this.loading_desc = "CONFIGURANDO ROLES ...";
          await this.$store.dispatch("getRoles");
          let newRole = null;
          if (this.$store.getters.user.admin) {
            newRole = {
              faena_id: this.contract.faena_id,
              admin: true,
            };
          } else {
            newRole = {
              faena_id: this.contract.faena_id,
            };
          }
          this.loading_desc = "OBTENIENDO ÁREAS ...";
          // Obtener áreas
          if (this.$store.getters.areas.length === 0) {
            // no hay store de areas
            await this.getContractArea(this.contract.area_id);
            if (this.area && this.area.area_padre_id) {
              await this.getContractFatherArea(this.area.area_padre_id);
            } // if
          } else {
            this.area = findArea(this.contract.area_id);
            this.fatherArea = findArea(this.area.area_padre_id);
          } // if
          // Area
          newRole.area_id = this.area._id;
          // Role
          newRole.role = my_role;
          // reset datos de otros roles
          await this.$store.dispatch("resetEmpresasFaena");
          await this.$store.dispatch("resetAreas");
          await this.$store.dispatch("resetContract");
          await this.$store.dispatch("resetUserContractByRole");
          await this.$store.dispatch("setRole", newRole);
          let permitido = false;
          if (this.$store.getters.user.admin) {
            permitido = true;
          } else if (
            this.contract.revisores[my_role] &&
            this.contract.revisores[my_role].includes(
              this.$store.getters.user._id
            )
          ) {
            permitido = true;
          } else if (my_role === "manager") {
            if (this.area.manager_id === this.$store.getters.user._id) {
              permitido = true;
            }
            if (this.fatherArea.manager_id === this.$store.getters.user._id) {
              permitido = true;
            }
          } else if (my_role === "super") {
            if (this.area.super_id === this.$store.getters.user._id) {
              permitido = true;
            }
            if (this.fatherArea.super_id === this.$store.getters.user._id) {
              permitido = true;
            }
          }

          if (permitido === true) {
            let can_access_role = false;
            const mi_permiso = this.$store.getters.roles.filter(
              (el) => el.faena_id <= self.contract.faena_id
            );

            await mi_permiso.forEach(async (p) => {
              if (p.data && p.data.admin === true) {
                can_access_role = true;
              }
              if (
                p.data.areas &&
                p.data.areas[this.contract.area_id] &&
                p.data.areas[this.contract.area_id].includes(my_role)
              ) {
                can_access_role = true;
              }
              if (
                p.data.empresas &&
                p.data.empresas[this.contract.empresa_id] &&
                p.data.empresas[this.contract.empresa_id].includes(my_role)
              ) {
                can_access_role = true;
              }
              if (
                p.data.areas &&
                p.data.areas.GeneralAreasRoles &&
                p.data.areas.GeneralAreasRoles.includes(my_role)
              ) {
                can_access_role = true;
              }
              if (this.fatherArea.manager_id === this.$store.getters.user._id) {
                can_access_role = true;
              }
              if (this.fatherArea.super_id === this.$store.getters.user._id) {
                can_access_role = true;
              }
            });

            if (can_access_role === true) {
              this.loading_desc = "OBTENIENDO WORKFLOWS ...";
              // Obtener Workflows
              const cwf = this.contract.workflows;
              if (this.$store.getters.workflows.length === 0) {
                // no hay store de Workflows
                await this.getWorkflowByType("salud", cwf.salud);
                await this.getWorkflowByType("seguridad", cwf.seguridad);
                await this.getWorkflowByType(
                  "medioambiente",
                  cwf.medioambiente
                );
              } else {
                this.workflows.salud = findWorkflow(cwf.salud);
                this.workflows.seguridad = findWorkflow(cwf.seguridad);
                this.workflows.medioambiente = findWorkflow(cwf.medioambiente);
              } // if
              this.loading_desc = "OBTENIENDO PARTICIPANTES DEL CONTRATO ...";
              // Obtener personas del contrato
              await this.getUsersFaena(this.$store.getters.role.faena_id);
              this.contractPeople = this.usersFaena;
              this.loading_desc = "OBTENIENDO INVENTARIO ...";
              // Obtener inventario
              await this.getInventory();
              this.loadingAllDataRequired = false;

              if (this.$store.getters.allcontractsUser.length === 0) {
                await this.$store.dispatch(
                  "getAllContractsFaena",
                  this.contract.faena_id
                );
              }
              if (this.$store.getters.empresas.length === 0) {
                await this.$store.dispatch(
                  "getEmpresasByFaena",
                  this.contract.faena_id
                );
              }
              this.loading_desc = "OBTENIENDO FAENAS ...";
              if (this.$store.getters.faenas.length === 0) {
                await this.$store.dispatch("getFaenas");
              }
              if (this.$store.getters.areas.length === 0) {
                await this.$store.dispatch(
                  "getAreasbyFaena",
                  this.contract.faena_id
                );
              }
              this.loadingLogin = false;
              this.dialogVisible = false;
            } else {
              this.loadingLogin = false;
              this.errors.push("USUARIO NO POSEE EL ROL A REVISAR");
              await this.$store.dispatch("resetEmpresasFaena");
              await this.$store.dispatch("resetAreas");
              await this.$store.dispatch("resetContract");
              await this.$store.dispatch("resetUserAllContracts");
              await this.$store.dispatch("resetUserContractByRole");
              await this.$store.dispatch("latestState", null);
              await this.$store.dispatch("logout", this.$store.getters.user.id_sesion);
            }
          } else {
            this.loadingLogin = false;
            this.errors.push("USUARIO NO PERTENECE AL CONTRATO");
            await this.$store.dispatch("resetEmpresasFaena");
            await this.$store.dispatch("resetAreas");
            await this.$store.dispatch("resetContract");
            await this.$store.dispatch("resetUserAllContracts");
            await this.$store.dispatch("resetUserContractByRole");
            await this.$store.dispatch("latestState", null);
            await this.$store.dispatch("logout", this.$store.getters.user.id_sesion);
          }
        } else {
          this.loadingLogin = false;
        }
      });
    },
    goBack() {
      window.history.go(-1);
    },
    isActiveContract() {
      if (this.contract.tipo_contrato == "Propio") return true;
      return moment(this.contract.fecha_fin) - new Date() >= 0;
    },
    inventoryStatusText() {
      return this.inventory && this.inventory.status
        ? this.auxStatus[parseInt(this.inventory.status, 10)].text
        : this.$t("No Iniciado");
    },
    inventoryStatusColor() {
      return this.inventory && this.inventory.status
        ? this.auxStatus[parseInt(this.inventory.status, 10)].colorClass
        : "gray";
    },
    getSeguimiento(id) {
      this.loading_seguimiento = true;
      const self = this;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      axios
        .get(`/inventarios/getSeguimiento/${id}`, config)
        .then((response) => {
          self.seguimiento = response.data;
          self.loading_seguimiento = false;
        });
    },
    getSummary(id) {
      this.loading_summary = true;
      const self = this;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      axios
        .post(`/inventarios/summaryReviewer`, {
          id_inv: id
        }, config)
        .then((response) => {
          if (response.data.status === false) {
            self.summary = [];
            this.loading_summary = false;
          } else {
            self.summary = response.data;
            this.loading_summary = false;
          }
        });
    },
  },
};
</script>

<style scoped>
.content {
  min-height: 50vh;
}
</style>
